module.exports = __webpack_public_path__ + "img/media_youtube_nor.30ae379f.svg";